import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AdvancedSearchState {
  isAdvanceSearch: boolean;
  caseId: string;
  dateOfRegistration: string;
  selectedPriority: (string | number)[];
  selectedCaseReview: (string | number)[];
  claimNo: string;
  wcabNo: string;
  panelNo: string;
  fileNo: string;
  caseName: string;
  caseNumber: string;
  adjNo: string;
  selectedCaseStage: (string | number)[];
  name: string;
  ssnNo: string;
  selectedInjuryType: (string | number)[];
  selectedSeverityOfInjury: (string | number)[];
  dateOfIncident: string;
  employer: string;
  selectedApplicantAttrorney: (string | number)[];
  selectedDefenceAttorney: (string | number)[];
  selectedClient: (string | number)[];
  selectedInsurance: (string | number)[];
  appointmentConfirmationNo: string;
  appintmentdateRange: string;
  startTime: string;
  selectedAppointmentStatus: (string | number)[];
  selectedClinic: (string | number)[];
  selectedQME: (string | number)[];
  selectedQMECategory: (string | number)[];
  selectedQMEType: (string | number)[];
  isInterpreterReq: string;
  ismedicalExam: string;
  selectedDocumentTypeIds: (string | number)[];
  selectedDocumentCategoryIds: (string | number)[];
  fileName: string;
  addlFileDesc: string;
  uploadedByName: string;
  uploadDateTime: string;
  additionalComments: string;
}
const initialState: AdvancedSearchState = {
  isAdvanceSearch: false,
  caseId: "",
  dateOfRegistration: "",
  selectedPriority: [],
  selectedCaseReview: [],
  claimNo: "",
  wcabNo: "",
  panelNo: "",
  fileNo: "",
  caseName: "",
  caseNumber: "",
  adjNo: "",
  selectedCaseStage: [],
  name: "",
  ssnNo: "",
  selectedInjuryType: [],
  selectedSeverityOfInjury: [],
  dateOfIncident: "",
  employer: "",
  selectedApplicantAttrorney: [],
  selectedDefenceAttorney: [],
  selectedClient: [],
  selectedInsurance: [],
  appointmentConfirmationNo: "",
  appintmentdateRange: "",
  startTime: "",
  selectedAppointmentStatus: [],
  selectedClinic: [],
  selectedQME: [],
  selectedQMECategory: [],
  selectedQMEType: [],
  isInterpreterReq: "",
  ismedicalExam: "",
  selectedDocumentTypeIds: [],
  selectedDocumentCategoryIds: [],
  fileName: "",
  addlFileDesc: "",
  uploadedByName: "",
  uploadDateTime: "",
  additionalComments: "",
};

const advancedSearchSlice = createSlice({
  name: "advancedSearch",
  initialState,
  reducers: {
    setAdvancedSearchData: (
      state,
      action: PayloadAction<Partial<AdvancedSearchState>>
    ) => {
      Object.assign(state, action.payload); // Allows partial updates without overwriting the whole state
    },
    resetAdvancedSearchData: () => initialState, // Cleaner reset by directly returning initial state
    setIsAdvanceSearch: (state, action: PayloadAction<boolean>) => {
      state.isAdvanceSearch = action.payload;
    },
  },
});

export const {
  setAdvancedSearchData,
  resetAdvancedSearchData,
  setIsAdvanceSearch,
} = advancedSearchSlice.actions;

export default advancedSearchSlice.reducer;
